import React from 'react';
import { Parallax, ParallaxProvider} from 'react-scroll-parallax';
// import FontAwesomeIcon from '@fortawesome/react-fontawesome'
// import Question from '@fortawesome/fontawesome-free-solid/faQuestion'
import {TimelineLite} from "gsap/TimelineLite";
import Links from './Links'

import WithAnimation from './WithAnimation'
import Footer from './Footer'
import { Power4 } from "gsap";

import '../css/PageHeader.css'

class WithHeader extends WithAnimation {
  constructor(props) {
    super(props);

    this.PageContentsAnimation = new TimelineLite({ paused: false })
    this.PageTitleAnimation = new TimelineLite({ paused: false })
  }

  componentWillReceiveProps(nextprops) {
    if( nextprops.title !== this.props.title) {
      this.animationRestart()
    this.PageContentsAnimation.restart()
      this.PageTitleAnimation.restart()
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.Timeline.fromTo('#header-hr', 3, { opacity: 0 }, { ease: Power4.easeInOut, width: "300px", x: "20px", opacity: 1 })
    this.animationStart() 

    this.PageContentsAnimation.fromTo('#page-contents', 1, { opacity: 0 }, { opacity: 1 });
    this.PageTitleAnimation.fromTo('#page-title', 2, { opacity: 0, x: -20 }, { opacity: 1, x:0 });
  }

  render() {
    const { title, bannerImg, children } = this.props;
    const bannerBg = { backgroundImage: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)), url(${bannerImg})` }

    return (
      <div className="page">
        <div className="page-header" style={bannerBg}>
          <ParallaxProvider>
          <div className="page-title">
            <Parallax offsetYMin={0} offsetYMax={100}>
              <h2 id="page-title">{ title }</h2>
              <hr className="solid-white" id="header-hr" />
            </Parallax>
          </div>
          </ParallaxProvider>
          <Links />
        </div>
        <div className="page-content" id="page-contents">
        { React.cloneElement(children, { ...this.props}) }
        </div>
        <Footer />
      </div>
    );
  }
}

  // <FontAwesomeIcon icon={Question} size="2x" className="plus-circle"/>
export default WithHeader;



// WEBPACK FOOTER //
// ./src/components/WithHeader.jsx